// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Accessibility utilities */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Host component styling */
:host {
  display: block;
  width: 100%;
}
:host:not(:last-child) {
  margin-bottom: 10px;
}
:host:focus-within .order-item {
  box-shadow: 0px 3px 10px 0px rgba(79, 97, 79, 0.3);
  outline: 2px solid var(--ion-color-primary);
}

/* Order item card */
.order-item {
  width: 100%;
  background: white;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0px 1.95px 7.3px 0px rgba(79, 97, 79, 0.1490196078);
  position: relative;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  /* Image section */
  /* Reset padding on columns */
  /* Item name and price typography */
  /* Container for flexible text content */
}
.order-item:hover {
  box-shadow: 0px 3px 10px 0px rgba(79, 97, 79, 0.2);
}
.order-item .img_section {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.order-item .img_section .product-image {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  object-fit: contain;
}
.order-item ion-col {
  padding: 0 !important;
}
.order-item .order-article-name, .order-item .article-price {
  font-size: 16px;
  color: var(--ion-color-secondary);
  height: -moz-fit-content;
  height: fit-content;
  margin: 0;
  font-family: AppFontBold, sans-serif;
}
.order-item .flex-text {
  min-height: 50px;
  padding: 5px 0;
}

/* Action buttons container */
.icons_block {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Edit and delete buttons section */
.edit_section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* Button styling */
}
.edit_section .edit-btn {
  background: transparent;
  border: none;
  padding: 5px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 4px;
  transition: background-color 0.2s ease, transform 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Icon sizing */
}
.edit_section .edit-btn:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.edit_section .edit-btn:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.edit_section .edit-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.edit_section .edit-btn:active {
  transform: scale(0.95);
}
.edit_section .edit-btn ion-icon {
  height: 30px;
  width: 30px;
}

/* Quantity selector */
.quantity-selector {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* Quantity text */
  /* Quantity buttons */
}
.quantity-selector .quantity {
  color: var(--ion-color-secondary);
  font-size: 18px;
  font-family: AppFontBold, sans-serif;
  margin: 0 8px;
}
.quantity-selector .quantity-btn {
  background: transparent;
  border: none;
  padding: 5px;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease, transform 0.2s ease;
  /* Focus styles */
  /* Keyboard focus styles */
  /* Hover state */
  /* Active state */
  /* Icon sizing */
}
.quantity-selector .quantity-btn:focus {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-selector .quantity-btn:focus-visible {
  outline: 2px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-selector .quantity-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.quantity-selector .quantity-btn:active {
  transform: scale(0.95);
}
.quantity-selector .quantity-btn ion-icon {
  height: 30px;
  width: 30px;
  margin: 0;
}

/* Vertical centering utility */
.center-vertical {
  display: flex;
  align-items: center;
}

/* Option details */
.option-name {
  padding-bottom: 5px;
  margin: 0;
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.option-name .option-price {
  font-weight: bold;
}

/* Price and quantity row spacing */
.price-quantity-row {
  margin-top: 5px;
}

/* Item note styling */
.note {
  font-style: italic;
  font-size: 13px;
  color: var(--ion-color-medium);
  margin-top: 5px;
}

/* High contrast mode enhancements */
.bsg-high-contrast .order-item {
  border: 2px solid black;
  box-shadow: none;
}
.bsg-high-contrast .order-item:focus-within {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .order-article-name, .bsg-high-contrast .article-price, .bsg-high-contrast .option-name, .bsg-high-contrast .quantity {
  color: black !important;
}
.bsg-high-contrast .edit-btn:focus, .bsg-high-contrast .quantity-btn:focus {
  outline: 3px solid #0078d7;
  box-shadow: none;
}
.bsg-high-contrast .edit-btn ion-icon, .bsg-high-contrast .quantity-btn ion-icon {
  color: black;
}
.bsg-high-contrast .note {
  color: black;
  border-top: 1px solid black;
  padding-top: 5px;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .order-item .img_section .product-image {
    width: 80px;
    height: 80px;
  }
  .order-item .order-article-name, .order-item .article-price {
    font-size: 14px;
  }
  .order-item .option-name {
    font-size: 12px;
  }
  .order-item .quantity {
    font-size: 16px;
  }
  .order-item .quantity-btn ion-icon, .order-item .edit-btn ion-icon {
    height: 24px;
    width: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-list/order-list.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA,4BAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA,2BAAA;AACA;EACE,cAAA;EACA,WAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,kDAAA;EACA,2CAAA;AAFJ;;AAMA,oBAAA;AACA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,+DAAA;EACA,kBAAA;EACA,qDAAA;EAMA,kBAAA;EAgBA,6BAAA;EAKA,mCAAA;EASA,wCAAA;AAnCF;AACE;EACE,kDAAA;AACJ;AAGE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAGI;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;AADN;AAME;EACE,qBAAA;AAJJ;AAQE;EACE,eAAA;EACA,iCAAA;EACA,wBAAA;EAAA,mBAAA;EACA,SAAA;EACA,oCAAA;AANJ;AAUE;EACE,gBAAA;EACA,cAAA;AARJ;;AAYA,6BAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AATF;;AAYA,oCAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EAEA,mBAAA;AAVF;AAWE;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,2DAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;EAKA,gBAAA;AA5BJ;AAOI;EACE,2CAAA;EACA,mBAAA;AALN;AASI;EACE,2CAAA;EACA,mBAAA;AAPN;AAWI;EACE,qCAAA;AATN;AAaI;EACE,sBAAA;AAXN;AAeI;EACE,YAAA;EACA,WAAA;AAbN;;AAkBA,sBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EAEA,kBAAA;EAQA,qBAAA;AAvBF;AAgBE;EACE,iCAAA;EACA,eAAA;EACA,oCAAA;EACA,aAAA;AAdJ;AAkBE;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2DAAA;EAEA,iBAAA;EAMA,0BAAA;EAMA,gBAAA;EAKA,iBAAA;EAKA,gBAAA;AAnCJ;AAcI;EACE,2CAAA;EACA,mBAAA;AAZN;AAgBI;EACE,2CAAA;EACA,mBAAA;AAdN;AAkBI;EACE,qCAAA;AAhBN;AAoBI;EACE,sBAAA;AAlBN;AAsBI;EACE,YAAA;EACA,WAAA;EACA,SAAA;AApBN;;AAyBA,+BAAA;AACA;EACE,aAAA;EACA,mBAAA;AAtBF;;AAyBA,mBAAA;AACA;EACE,mBAAA;EACA,SAAA;EACA,eAAA;EACA,iCAAA;AAtBF;AAwBE;EACE,iBAAA;AAtBJ;;AA0BA,mCAAA;AACA;EACE,eAAA;AAvBF;;AA0BA,sBAAA;AACA;EACE,kBAAA;EACA,eAAA;EACA,8BAAA;EACA,eAAA;AAvBF;;AA0BA,oCAAA;AAEE;EACE,uBAAA;EACA,gBAAA;AAxBJ;AA0BI;EACE,0BAAA;AAxBN;AA4BE;EACE,uBAAA;AA1BJ;AA8BI;EACE,0BAAA;EACA,gBAAA;AA5BN;AA+BI;EACE,YAAA;AA7BN;AAiCE;EACE,YAAA;EACA,2BAAA;EACA,gBAAA;AA/BJ;;AAmCA,2BAAA;AC5PE;ED+PE;IACE,WAAA;IACA,YAAA;EAjCJ;EAoCE;IACE,eAAA;EAlCJ;EAqCE;IACE,eAAA;EAnCJ;EAsCE;IACE,eAAA;EApCJ;EAwCI;IACE,YAAA;IACA,WAAA;EAtCN;AACF","sourcesContent":["@import '../../../theme/mixins';\n\n/* Accessibility utilities */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Host component styling */\n:host {\n  display: block;\n  width: 100%;\n  \n  &:not(:last-child) {\n    margin-bottom: 10px;\n  }\n  \n  &:focus-within .order-item {\n    box-shadow: 0px 3px 10px 0px rgba(79, 97, 79, 0.3);\n    outline: 2px solid var(--ion-color-primary);\n  }\n}\n\n/* Order item card */\n.order-item {\n  width: 100%;\n  background: white;\n  border-radius: 10px;\n  padding: 10px;\n  box-shadow: 0px 1.95px 7.3px 0px #4F614F26;\n  position: relative;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n  \n  &:hover {\n    box-shadow: 0px 3px 10px 0px rgba(79, 97, 79, 0.2);\n  }\n  \n  /* Image section */\n  .img_section {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n    .product-image {\n      width: 100px;\n      height: 100px;\n      margin: 0 auto;\n      object-fit: contain;\n    }\n  }\n  \n  /* Reset padding on columns */\n  ion-col {\n    padding: 0 !important;\n  }\n  \n  /* Item name and price typography */\n  .order-article-name, .article-price {\n    font-size: 16px;\n    color: var(--ion-color-secondary);\n    height: fit-content;\n    margin: 0;\n    font-family: AppFontBold, sans-serif;\n  }\n  \n  /* Container for flexible text content */\n  .flex-text {\n    min-height: 50px;\n    padding: 5px 0;\n  }\n}\n\n/* Action buttons container */\n.icons_block {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n/* Edit and delete buttons section */\n.edit_section {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  \n  /* Button styling */\n  .edit-btn {\n    background: transparent;\n    border: none;\n    padding: 5px;\n    cursor: pointer;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 4px;\n    transition: background-color 0.2s ease, transform 0.2s ease;\n    \n    /* Focus styles */\n    &:focus {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Keyboard focus styles */\n    &:focus-visible {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Hover state */\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n    \n    /* Active state */\n    &:active {\n      transform: scale(0.95);\n    }\n    \n    /* Icon sizing */\n    ion-icon {\n      height: 30px;\n      width: 30px;\n    }\n  }\n}\n\n/* Quantity selector */\n.quantity-selector {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  \n  /* Quantity text */\n  .quantity {\n    color: var(--ion-color-secondary);\n    font-size: 18px;\n    font-family: AppFontBold, sans-serif;\n    margin: 0 8px;\n  }\n  \n  /* Quantity buttons */\n  .quantity-btn {\n    background: transparent;\n    border: none;\n    padding: 5px;\n    cursor: pointer;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background-color 0.2s ease, transform 0.2s ease;\n    \n    /* Focus styles */\n    &:focus {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Keyboard focus styles */\n    &:focus-visible {\n      outline: 2px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Hover state */\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n    \n    /* Active state */\n    &:active {\n      transform: scale(0.95);\n    }\n    \n    /* Icon sizing */\n    ion-icon {\n      height: 30px;\n      width: 30px;\n      margin: 0;\n    }\n  }\n}\n\n/* Vertical centering utility */\n.center-vertical {\n  display: flex;\n  align-items: center;\n}\n\n/* Option details */\n.option-name {\n  padding-bottom: 5px;\n  margin: 0;\n  font-size: 14px;\n  color: var(--ion-color-secondary);\n  \n  .option-price {\n    font-weight: bold;\n  }\n}\n\n/* Price and quantity row spacing */\n.price-quantity-row {\n  margin-top: 5px;\n}\n\n/* Item note styling */\n.note {\n  font-style: italic;\n  font-size: 13px;\n  color: var(--ion-color-medium);\n  margin-top: 5px;\n}\n\n/* High contrast mode enhancements */\n.bsg-high-contrast {\n  .order-item {\n    border: 2px solid black;\n    box-shadow: none;\n    \n    &:focus-within {\n      outline: 3px solid #0078d7;\n    }\n  }\n  \n  .order-article-name, .article-price, .option-name, .quantity {\n    color: black !important;\n  }\n  \n  .edit-btn, .quantity-btn {\n    &:focus {\n      outline: 3px solid #0078d7;\n      box-shadow: none;\n    }\n    \n    ion-icon {\n      color: black;\n    }\n  }\n  \n  .note {\n    color: black;\n    border-top: 1px solid black;\n    padding-top: 5px;\n  }\n}\n\n/* Responsive adjustments */\n@include mobile {\n  .order-item {\n    .img_section .product-image {\n      width: 80px;\n      height: 80px;\n    }\n    \n    .order-article-name, .article-price {\n      font-size: 14px;\n    }\n    \n    .option-name {\n      font-size: 12px;\n    }\n    \n    .quantity {\n      font-size: 16px;\n    }\n    \n    .quantity-btn, .edit-btn {\n      ion-icon {\n        height: 24px;\n        width: 24px;\n      }\n    }\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
